import { API_URL } from "@/config";

const RESTRICTED_COUNTRIES = new Set(["GB", "FR", "DE"]);

const RESTRICTED_US_STATES = new Set([
  "AL", "AR", "AZ", "FL", "GA", "ID", "IN", "KS", "KY", "LA",
  "MO", "MS", "MT", "NC", "ND", "NE", "OH", "OK", "SC", "SD",
  "TN", "TX", "UT", "VA", "WY",
]);

const GOCAM_SCRIPT_ID = "gocam-avs";
const GOCAM_SCRIPT_SRC =
  "https://go.cam/static/js/app/avsHosted.js?p=824&key=Iu8pMNjSdkiWfDPL74XguCnzcHMStI4HgPYRoQYkrlo&background=ffffff&foreground=000000&buttonBackground=9acd1f&buttonForeground=ffffff&language=en&autoStart=1";

function isRestricted(countryCode: string, regionCode: string): boolean {
  if (RESTRICTED_COUNTRIES.has(countryCode)) return true;
  if (countryCode === "US" && RESTRICTED_US_STATES.has(regionCode)) return true;
  return false;
}

export async function injectGoCamIfNeeded() {
  if (document.getElementById(GOCAM_SCRIPT_ID)) {
    return;
  }

  try {
    const res = await fetch(`${API_URL}/v1/geo`);
    const { countryCode, regionCode } = await res.json();

    if (!isRestricted(countryCode, regionCode)) {
      return;
    }

    const script = document.createElement("script");
    script.id = GOCAM_SCRIPT_ID;
    script.type = "application/javascript";
    script.src = GOCAM_SCRIPT_SRC;
    document.body.appendChild(script);
  } catch {
    // API failure — skip the modal
  }
}
